/**
 * Fall Risk Dashboard Overlay
 * 
 * Admin-only overlay wrapper for the Fall Risk Dashboard component
 */

import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import FallRiskDashboard from "@/components/FallRiskDashboard";
import { AlertTriangle } from "lucide-react";

export default function FallRiskDashboardOverlay({ isOpen, onClose, userRole }) {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="w-[1100px] max-w-[95vw] bg-slate-900 border-slate-700 text-white overflow-y-auto">
        <SheetHeader>
          <SheetTitle className="text-white flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-amber-400" />
            Fall Risk Dashboard
          </SheetTitle>
          <SheetDescription className="text-slate-400">
            Census-wide fall analytics and risk management (Admin only)
          </SheetDescription>
        </SheetHeader>
        
        <div className="mt-4">
          <FallRiskDashboard userRole={userRole} />
        </div>
      </SheetContent>
    </Sheet>
  );
}

export { FallRiskDashboardOverlay };
